<div class="loading" style="margin-top:15px;">
    <div class="cpanel">
        <div class="cpanel-header">
            <div class="row" *ngIf="!size.small">
                <div class="col-9">
                    <div class="cpanel-icon-div">
                        <i class="cpanel-icon fas fa-adjust"></i>
                    </div>
                    <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; {{title}}</div>
                </div>
                <div class="col-3 text-right">
                    <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f2', title)">Info</button>
                </div>
            </div>
            <table *ngIf="size.small">
                <tr>
                    <td class="pr10">
                        <i class="cpanel-icon fas fa-adjust"></i>
                    </td>
                    <td>
                        <div class="mobile-title">
                            {{title}} &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f2', title)">Info</a>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="cpanel-content">
            <form name="iForm" (ngSubmit)="onSubmit()" [formGroup]="iForm">
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="outline" class="wp100 bold" style="margin-bottom: -10px !important;">
                            <mat-label>Address</mat-label>
                            <input matInput placeholder="Start typing address..." formControlName="userInput" [matAutocomplete]="auto">
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let item of filteredAddresses" [value]="item.streetAddress" (onSelectionChange)="onAddressSelect(item)">
                                <span>{{ item.streetAddress }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 10px !important;">
                    <div class="col-md-12 font-bold c-success text-center">
                        <span>== OR ==</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Address Line 1</mat-label>
                            <input matInput placeholder="Address Line 1" formControlName="addressLine1" required>
                            <mat-error *ngIf="f.addressLine1.errors?.required && f.addressLine1.touched">Address Line 1 is required </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Address Line 2</mat-label>
                            <input matInput placeholder="Address Line 2" formControlName="addressLine2">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Suburb</mat-label>
                            <input matInput placeholder="Suburb" formControlName="suburb" required>
                            <mat-error *ngIf="f.suburb.errors?.required && f.suburb.touched">Suburb is required </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-select placeholder="State" formControlName="state" required>
                                <mat-option value="NSW">NSW</mat-option>
                                <mat-option value="QLD">QLD</mat-option>
                                <mat-option value="VIC">VIC</mat-option>
                                <mat-option value="WA">WA</mat-option>
                                <mat-option value="SA">SA</mat-option>
                                <mat-option value="ACT">ACT</mat-option>
                                <mat-option value="TAS">TAS</mat-option>
                            </mat-select>
                            <mat-error *ngIf="f.state.errors?.required && f.state.touched">State is required </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Postcode</mat-label>
                            <input matInput placeholder="Postcode" formControlName="postCode" mask="0*" required>
                            <mat-error *ngIf="f.postCode.errors?.required && f.postCode.touched">Postcode is required </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="outline" class="wp100 bold">
                            <mat-label>Country</mat-label>
                            <input matInput placeholder="Country" formControlName="country" required>
                            <mat-error *ngIf="f.country.errors?.required && f.country.touched">Country is required </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="row" *ngIf="isFormChanged">
                    <div class="col-md-12 align-right">
                        <span *ngIf="iForm.valid && isFormChanged" class="c-green bold">Press Save button to Save Changes <i class="fas fa-arrow-circle-right fs12 c-dark-grey blink"></i></span>&nbsp;&nbsp;&nbsp;
                        <button mat-raised-button color="primary" class="sm30 c-white bold" type="submit" [disabled]="!iForm.valid">Save</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
    <ngx-loading [show]="iloading"></ngx-loading>
</div>